import type { GridInitialState } from "@mui/x-data-grid";
import { cpfMask } from "utils/cpf";

/**
 * why: "Corrigir e-mail" do monitor abre Editar dados com `?cpf=<11 dígitos>`; a coluna guarda o CPF
 * com máscara. Filtro de coluna (e não o filtro rápido) porque a tabela não tem barra de busca: assim
 * ele aparece no cabeçalho e o usuário consegue tirar.
 * invariant: só 11 dígitos; qualquer outro valor é ignorado e a tabela abre inteira.
 * invariant: o retorno entra no `initialState` da DataGrid, que lê o filtro em `filter.filterModel`.
 */
export function initialCpfFilter(search: string): Pick<GridInitialState, "filter"> | undefined {
  const raw = new URLSearchParams(search).get("cpf") ?? "";
  if (!/^\d{11}$/.test(raw)) return undefined;
  return { filter: { filterModel: { items: [{ field: "taxPayerId", operator: "equals", value: cpfMask(raw) }] } } };
}
